import Map from './Map';

window.addEventListener('DOMContentLoaded', (): void => {
  const btns: HTMLElement[] = Array.from(document.querySelectorAll('.view-on-map'));
  const close: HTMLElement = document.querySelector('.close-modal');
  const modalBg: HTMLElement = document.querySelector('.modal-background');
  const modal: HTMLElement = document.querySelector('#map-modal');
  const viewRouteButton: HTMLElement = document.querySelector('.googleMap-viewRouteButton');

  const toggleModal = (): void => {
    switch (modal.style.display) {
      case 'none':
        modalBg.style.display = 'block';
        modal.style.display = 'block';
        break;
      case 'block':
        modalBg.style.display = 'none';
        modal.style.display = 'none';
        break;
      default:
        modalBg.style.display = 'none';
        modal.style.display = 'none';
        break;
    }
  };

  const renderDirections = (map, googleMaps, result): void => {
    const DirectionsRenderer = new googleMaps.DirectionsRenderer();
    DirectionsRenderer.setMap(map);
    DirectionsRenderer.setDirections(result);
  };

  const displayRoute = (map, googleMaps, origin, destination): void => {
    const directionService = new googleMaps.DirectionsService();
    const routeObject = {
      origin,
      destination,
      travelMode: 'WALKING',
    };
    const routeCallback = (result, status: string): void => {
      if (status === 'OK') {
        renderDirections(map, googleMaps, result);
      }
    };
    directionService.route(routeObject, routeCallback);
  };

  const requestGeolocationPermission = (el: HTMLElement, map, googleMaps, marker): boolean => {
    const geoSuccess = (position): void => {
      const { latitude, longitude } = position.coords;
      const userMarker = map.addMarker(latitude, longitude, 'My Location');
      displayRoute(map.map, googleMaps, userMarker.position, marker.position);
      marker.setMap(null);
    };

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(geoSuccess);
    }
  };

  const initMap = async (el: HTMLElement): Promise<void> => {
    const mapElm: HTMLElement = document.querySelector('#inner-map');
    const pointsOfInterest = JSON.parse(el.dataset.pointsOfInterest);

    if (!pointsOfInterest.length) return;

    const map: Map = new Map();
    const placeData = {
      center: {
        lat: Number(pointsOfInterest[0].latitude),
        lng: Number(pointsOfInterest[0].longitude),
      },
      zoom: 14,
    };

    const googleMaps = await map.loadGoogleMaps();

    await map.createMap(googleMaps, mapElm, placeData);

    pointsOfInterest.forEach((pointOfInterest): void => {
      const {
        type,
        showAddress,
      } = pointOfInterest;

      if (showAddress) {
        const marker = map.addLinkMarker(pointOfInterest, type);
        const viewRoute = (): void => {
          requestGeolocationPermission(el, map, googleMaps, marker);
        };
        viewRouteButton.addEventListener('click', viewRoute);
      }
    });
  };

  const toggleModalWithMap = (el: HTMLElement): void => {
    toggleModal();
    initMap(el);
  };

  [close, modalBg].forEach((el: HTMLElement) => {
    if (el === null) { return; }
    el.addEventListener('click', (): void => {
      toggleModal();
    });
  });

  btns.forEach((btn: HTMLElement) => {
    btn.addEventListener('click', (event: Event): void => {
      toggleModalWithMap(event.currentTarget as HTMLElement);
    });
  });
});
